import { useMutation } from '@tanstack/react-query';
import queryString from 'query-string';

import { COMPANY_OVERVIEW_FEATURE_KEY, CONTACTS_FEATURE_KEY, INSIGHTS_FEATURE_KEY } from '../../domain/gainAccessView';
import { HttpClient } from '../../services/HttpClient';

import { useUserQuery } from './useUserQuery';

const featureToSubject = {
  extension: 'Contact Sales: Sales Intelligence Extension',
  [INSIGHTS_FEATURE_KEY]: 'Contact Sales: SI Extension AI Insights Full Access',
  [COMPANY_OVERVIEW_FEATURE_KEY]: 'Contact Sales: SI Extension Company Overview Full Access',
  [CONTACTS_FEATURE_KEY]: 'Contact Sales: SI Extension Contacts Full Access',
} as const;

export type Feature = keyof typeof featureToSubject;

export const useRequestAccessMutation = () => {
  const userQuery = useUserQuery();

  return useMutation({
    mutationKey: [`${userQuery.data?.userId ?? ''}-request-access`],
    mutationFn: (feature: Feature) => {
      const user = userQuery.data!;
      const payload = {
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        phone: user.phone ?? '',
        planId: user.accountType,
        message: '',
        subject: featureToSubject[feature],
        company: '',
        formLocationUrl: '',
      };
      const body = queryString.stringify(payload);
      const options: RequestInit = {
        credentials: 'include',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      };
      return HttpClient.postForm('https://gro.similarweb.com/contactus/api/forms/contactus', body, options);
    },
  });
};
